import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 dark:text-foreground-950">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                最近中文字幕
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-300 max-w-md">
              专注提供最新影视作品的中文字幕更新信息，涵盖电影、电视剧等多个类别，帮助中文影视爱好者快速找到想看的带中文字幕内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <Link to="/" className="hover:text-accent-400 transition-colors">
                快速导航
              </Link>
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/category/movie" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  电影专区
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  电视剧专区
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  搜索资源
                </Link>
              </li>
              <li>
                <Link to="/favorites" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  我的收藏
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <Link to="/about" className="hover:text-accent-400 transition-colors">
                关于与联系
              </Link>
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li className="text-secondary-300 flex items-center gap-2">
                <i className="ri-mail-line"></i>
                feedback@zuijinzhongwen.demo
              </li>
              <li className="text-secondary-300">本站为演示站点</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-secondary-400">
          <p>© 2026 最近中文字幕 · 演示数据，仅用于展示与学习交流</p>
          <p>本站不提供任何影视播放与下载服务</p>
        </div>
      </div>
    </footer>
  );
}